import React from 'react';

import { useUnit } from 'effector-react';
import { Navigate } from 'react-router-dom';

import { User$ } from '../../effector/user';
import { UserRoles } from '../../types/userRoles';
import { PAGE_DASHBOARD, PAGE_STRATEGIES } from '../Routes';

export const DefaultRedirect: React.FC = () => {
  const user = useUnit(User$);

  const showDashboard =
    user?.role === UserRoles.Administrator ||
    user?.role === UserRoles.Manager ||
    user?.role === UserRoles.DigitalExpert;

  return <Navigate replace to={showDashboard ? PAGE_DASHBOARD : PAGE_STRATEGIES} />;
};
